import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {GuestGuard} from './guards/guest.guard';
import {AuthGuard} from './guards/auth.guard';
import {ErrorPageComponent} from './partials/error-page/error-page.component';

const routes: Routes = [
  {
    path: 'auth',
    canLoad: [GuestGuard],
    loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: '',
    canLoad: [AuthGuard],
    loadChildren: () => import('./modules/user/user.module').then(m => m.UserModule)
  },
  {
    path: 'pages/error',
    component: ErrorPageComponent
  },
  {
    path: '**',
    redirectTo: '/pages/error',
  }
];
@NgModule({
  imports: [ RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
